import GoogleIcon from '@/assets/icons/external/google_icon.svg';

export { GoogleIcon };
